import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  .logoWrapper {
    margin-top:10px;
    @media only screen and (max-width: 767px) {
      max-width: 150px;
    }
  }
`;

export const ButtonGroup = styled.div`
  
  .reusecore__button {
    font-weight: 500;
    border-radius: 5px;
    color: ${themeGet("colors.banner", "#171717")} !important;
    &:first-child {
      margin-right: 20px;
      &:hover {
        opacity: 0.95;
      }
    }
    @media only screen and (max-width: 767px) {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
`;

export { Container };
